import Carousel from "components/UI/Carousel/Carousel";

import { CAROUSEL_ARTICLES_SLIDES } from "../../carouselData";

import "./ArticlesSection.scss";

const ArticlesSection = ({ isMobile }) => {
  return (
    <section className="articles-section">
      <h3 className="section__title">Видео-разборы наших кейсов и статьи</h3>
      <Carousel slides={CAROUSEL_ARTICLES_SLIDES} variant="compact" itemsVisible={isMobile ? 1 : 4} itemWidth={isMobile ? 294 : 280} withRightFade={true} isMobile={isMobile} />
    </section>
  );
};

export default ArticlesSection;
